import {createApp} from '../../../../../vendor/vue/dist/vue.esm-browser.js';
import {get} from "../../../../website/assets/javascript/partials/data-manager";
import Animate from "../../../../website/assets/javascript/partials/animate";

export default class SessionTimer {
    constructor($el) {
        this.$el = $el;

        this.createVueApp();

    }

    createVueApp() {
        const blockId = this.$el.dataset.blockId;
        const block = this.$el
        const app = createApp({
            data() {
                return {
                    seconds: 0,
                    minutes: 0,
                    counter: 0,
                    showCounter: 0,
                    countdown: null
                };
            },
            computed: {
            },
            methods: {
                timeHandler() {
                    if (this.counter === 0){
                        this.stopCounter();
                        this.emitEndSession()
                        return;
                    }

                    this.showCounter = 1;
                    this.counter--;

                    if(this.seconds === 0) {
                        this.seconds = 60;
                        this.minutes--;
                    }

                    this.seconds--;
                },
                stopCounter() {
                    this.showCounter = 0;
                    clearInterval(this.countdown);
                },
                emitEndSession() {
                    const event = new CustomEvent("endCounterSession");
                    document.dispatchEvent(event);
                },
                createCounter(time) {
                    if(time < 1)
                    {
                        return;
                    }
                    this.counter = time;
                    this.minutes = Math.floor(time / 60);
                    this.seconds = time % 60;

                    this.countdown = setInterval(this.timeHandler, 1000);
                }
            },
             mounted() {

            },
            created() {
                document.addEventListener("startCounterSession", (e) => {
                    this.stopCounter();
                    this.createCounter(e.detail.time);
                });
                document.addEventListener("endCounterAfterMessage", (e) => {
                    this.stopCounter();
                });
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$el);
    }
}